import React from "react";
import Modal from "react-modal";
import Button from "./form/Button";

export default function BvrResultModal({ result, reference, onClose }) {
  if (!result) return null;

  const title = result.success
    ? "SDK verification response"
    : result.code === "CANCELLED"
      ? "Verification cancelled"
      : "Verification unsuccessful";

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      appElement={document.getElementById("root")}
      aria={{ labelledby: "bvr-result-title" }}
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      className="bg-white rounded-[24px] p-6 w-full max-w-lg max-h-[90vh] flex flex-col overflow-hidden outline-none"
    >
      <h2 id="bvr-result-title" className="text-[17px] font-semibold mb-3">{title}</h2>
      {reference && (
        <p className="text-[13px] text-gray mb-3 break-all">
          Reference sent: <span className="font-mono select-all">{reference}</span>
        </p>
      )}
      {typeof result.message === "string" && (
        <p className="text-[15px] mb-3">{result.message}</p>
      )}
      <p className="text-[13px] text-gray mb-3">
        Full response returned by the SDK (debug view). Tap continue to open the registration form with this data filled in.
      </p>
      <pre className="min-h-0 max-h-[60vh] flex-1 overflow-auto whitespace-pre-wrap break-all bg-gray-100 rounded-lg p-3 text-xs mb-4">
        {JSON.stringify(result, null, 2)}
      </pre>
      <Button type="button" eventAction={onClose} intent="primary" size="costum" roundness="pill">
        {result.success ? "Continue to registration" : "Close"}
      </Button>
    </Modal>
  );
}
